import { usePopupPosition as lib } from 'use-rects';
import type { UsePopupPositionParams } from 'use-rects';

export const usePopupPosition = (params?: UsePopupPositionParams) => {
  return lib({ ...params, delay: 20, trackVisible: false });
};
